<div>
  <span class="filter ms-0 me-2" [ngClass]="{ 'filter--large': showLargeBadges }" *ngFor="let sv of selectedValues; index as i" [tabIndex]="i">
    <span class="filter__label">{{ sv ? sv[labelName] : '' }}</span>
    <button class="filter__close" *ngIf="!isDisabled" (click)="removeItem(sv)"><i class="material-icons"> close </i></button>
  </span>
  <a *ngIf="selectedValues?.length > 0 && showClearAllOption" href role="button" class="clearAllLink" (click)="onClearAll(); $event.preventDefault()"
    >Clear All</a
  >
</div>
